const uriProduction = 'https://api.sabin.com.br'
const uriDeveloper = 'https://apidev.cloudsabin.com'
const uriStaging   = 'https://api-staging.cloudsabin.com'
const uriLocalhost = uriDeveloper

const urls = [
  { 'localhost:4200': uriLocalhost },
  { 'localhost:8080': uriLocalhost },
  {'backofficedev.cloudsabin.com': uriDeveloper},
  {'backoffice-staging.cloudsabin.com': uriStaging},
  { 'backoffice.sabin.com.br': uriProduction }
]

const urlFilter = urls.find((elem) => {
  return elem[window.location.host]
})

var uri = urlFilter[window.location.host]
if (uri === undefined) {
  console.info(`Not found environment key for host: ${window.location.host}\n, using ${uriDeveloper}`)
  uri = uriDeveloper
}

export default uri



// WEBPACK FOOTER //
// ./client/app/config/uri.js